import uclmlogo from '@assets/Institution/UCLM.png'
import sanhslogo from '@assets/Institution/SANHS.png'
import sceslogo from '@assets/Institution/SCES.png'
import beslogo from '@assets/Institution/BES.png'
import peslogo from '@assets/Institution/PES.png'

export const educationData = [
  {
    id: 1,
    institution: 'University of Cebu',
    degree: 'Bachelor of Science in Computer Science',
    period: '2022 - Present',
    location: 'AC Cortes Ave, Cebu City, Philippines',
    image: uclmlogo,
    website: 'https://www.uc.edu.ph/',
    achievements: [
      'Relevant coursework in Data Structures, Algorithms, and Software Engineering',
      'Attained Multiple Dean\'s Lister Awards for Academic Excellence',
    ]
  },
  {
    id: 2,
    institution: 'San Agustin National High School',
    degree: 'Information and Communication Technology (ICT) Strand',
    period: '2020 - 2022',
    location: 'San Agustin, Poblacion, Sagbayan, Bohol',
    image: sanhslogo,
    website: 'https://home.sanagustinnhs.net/',
    achievements: [
      'Graduated with honors',
    ]
  },
  {
    id: 3,
    institution: 'San Agustin National High School',
    degree: 'Junior High School',
    period: '2016 - 2020',
    location: 'San Agustin, Poblacion, Sagbayan, Bohol',
    image: sanhslogo,
    website: 'https://home.sanagustinnhs.net/',
    achievements: [
      'Graduated with honors',
    ]
  },
  {
    id: 4,
    institution: 'Sagbayan Central Elementary School',
    degree: 'Elementary Graduate',
    period: '2015 - 2016',
    location: 'Poblacion, Sagbayan, Bohol',
    image: sceslogo,
    website: 'https://www.facebook.com/p/Sagbayan-Central-Elementary-School-100070990836821/',
  },
  {
    id: 5,
    institution: 'Bankal Elementary School',
    degree: 'Elementary Transfer',
    period: '2013 - 2015',
    location: 'Bankal, Lapu-Lapu City, Cebu',
    image: beslogo,
    website: 'https://www.facebook.com/p/Administrator-Page-of-Bankal-Elementary-School-DepEd-Region-7-100064119214031/',
  },
  {
    id: 6,
    institution: 'Pusok Elementary School',
    degree: 'Elementary Transfer',
    period: '2010 - 2013',
    location: 'Pusok, Lapu-Lapu City, Cebu',
    image: peslogo,
    website: 'https://www.facebook.com/p/Pusok-Elementary-School-Lapu-Lapu-City-Division-61553965151767/',
  },
]
